import { useState, useEffect } from "react";
import { assinaturaService } from "../services/assinaturaService";
import { Assinatura } from "../interfaces/Assinatura";

export const useAssinaturas = () => {
  const [assinaturas, setAssinaturas] = useState<Assinatura[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchAssinaturas = async (showLoading = true) => {
    if (showLoading) {
      setIsLoading(true);
    }

    try {
      const data = await assinaturaService();
      setAssinaturas(Array.isArray(data) ? data : []);
    } finally {
      if (showLoading) {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchAssinaturas(true);
  }, []);

  return { assinaturas, isLoading, fetchAssinaturas };
};
